import React from "react";

import talentlenzResponsibleSelectionHumanDecisionFramework from "../../images/talentlenz-responsible-selection-human-decision-framework.png";

import "./TalentLenzResponsibleSelection.css";

const TALENTLENZ_RESPONSIBLE_SELECTION_STEPS = [
  {
    number: "01",
    title: "Consistent criteria",
    description: "Same defined evidence considered.",
    tone: "blue",
  },
  {
    number: "02",
    title: "Evidence visible",
    description: "Scores stay connected to evidence.",
    tone: "pink",
  },
  {
    number: "03",
    title: "Human review",
    description: "HR checks context before progression.",
    tone: "blue",
  },
  {
    number: "04",
    title: "Decision recorded",
    description: "Final action stays with the organisation.",
    tone: "pink",
  },
];

function TalentLenzResponsibleSelection() {
  return (
    <section
      id="talentlenz-responsible-selection"
      className="talentlenz-responsible-selection-section"
      aria-labelledby="talentlenz-responsible-selection-title"
    >
      <div className="talentlenz-responsible-selection-section__inner">
        <header className="talentlenz-responsible-selection-section__heading">
          <p className="talentlenz-responsible-selection-section__eyebrow">
            Responsible selection
          </p>

          <h2
            id="talentlenz-responsible-selection-title"
            className="talentlenz-responsible-selection-section__title"
          >
            <span className="talentlenz-responsible-selection-section__title-lines talentlenz-responsible-selection-section__title-lines--wide">
              Better systems
              <br />
              support better
              <br />
              human decisions.
            </span>

            <span className="talentlenz-responsible-selection-section__title-lines talentlenz-responsible-selection-section__title-lines--portrait">
              Better systems support
              <br />
              better human decisions.
            </span>
          </h2>
        </header>

        <div className="talentlenz-responsible-selection-section__support">
          <p className="talentlenz-responsible-selection-section__description">
            <span className="talentlenz-responsible-selection-section__description-lines talentlenz-responsible-selection-section__description-lines--desktop">
              TalentLenz structures evidence, highlights suitability
              <br />
              and explains the result. Your team reviews the evidence,
              <br />
              controls progression and decides what feedback is shared.
            </span>

            <span className="talentlenz-responsible-selection-section__description-lines talentlenz-responsible-selection-section__description-lines--landscape">
              TalentLenz structures evidence and explains
              <br />
              the result. Your team reviews the evidence,
              <br />
              controls progression and decides what
              <br />
              feedback is shared.
            </span>

            <span className="talentlenz-responsible-selection-section__description-lines talentlenz-responsible-selection-section__description-lines--portrait">
              TalentLenz structures evidence and explains the result. Your team
              <br />
              reviews the evidence, controls progression and decides what
              <br />
              feedback is shared.
            </span>

            <span className="talentlenz-responsible-selection-section__description-lines talentlenz-responsible-selection-section__description-lines--mobile">
              TalentLenz structures evidence and explains
              <br />
              the result. Your team reviews the evidence
              <br />
              and controls progression.
            </span>
          </p>
        </div>

        <aside className="talentlenz-responsible-selection-section__desktop-control-note">
          <span
            className="talentlenz-responsible-selection-section__desktop-control-dot"
            aria-hidden="true"
          />

          <span className="talentlenz-responsible-selection-section__desktop-control-text">
            Decision support—not autonomous hiring.
          </span>
        </aside>

        <figure className="talentlenz-responsible-selection-section__desktop-framework">
          <img
            className="talentlenz-responsible-selection-section__desktop-framework-image"
            src={talentlenzResponsibleSelectionHumanDecisionFramework}
            alt="Responsible selection framework showing consistent criteria, visible evidence, human review and a recorded organisational decision. TalentLenz provides decision support rather than autonomous hiring."
            loading="lazy"
            decoding="async"
          />
        </figure>

        <div className="talentlenz-responsible-selection-section__compact-framework">
          <ol
            className="talentlenz-responsible-selection-section__step-list"
            aria-label="TalentLenz responsible selection framework"
          >
            {TALENTLENZ_RESPONSIBLE_SELECTION_STEPS.map((step) => (
              <li
                key={step.number}
                className={[
                  "talentlenz-responsible-selection-section__step",
                  `talentlenz-responsible-selection-section__step--${step.tone}`,
                ].join(" ")}
              >
                <span className="talentlenz-responsible-selection-section__step-number">
                  {step.number}
                </span>

                <span className="talentlenz-responsible-selection-section__step-copy">
                  <strong className="talentlenz-responsible-selection-section__step-title">
                    {step.title}
                  </strong>

                  <small className="talentlenz-responsible-selection-section__step-description">
                    {step.description}
                  </small>
                </span>
              </li>
            ))}
          </ol>

          <aside className="talentlenz-responsible-selection-section__human-control">
            <span className="talentlenz-responsible-selection-section__human-control-label">
              Human control
            </span>

            <p className="talentlenz-responsible-selection-section__human-control-text">
              Decision support—not autonomous hiring.
            </p>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default TalentLenzResponsibleSelection;